import { Box, Flex, Icon, Text } from '@chakra-ui/react';
import { PRIMARY_BG } from '../../theme/brand';

/**
 * The one main-page title block used across the app: a brand-gradient icon tile,
 * the page title and a muted subtitle, with optional actions (buttons, filters)
 * pushed to the right. Matches the original Email Templates header so every page
 * reads the same.
 *
 *   <PageHeading icon={LuMail} title="Email Templates" subtitle="Manage your saved emails…">
 *     <Button>New</Button>
 *   </PageHeading>
 */
const PageHeading = ({ icon, title, subtitle, children, mb = 6 }) => (
  <Flex justify="space-between" align="center" mb={mb} wrap="wrap" gap={3}>
    {/* flex 1 1 320px: a long subtitle wraps beside the actions instead of pushing them to a new row */}
    <Flex align="center" gap={3} minW={0} flex="1 1 320px">
      {icon && (
        <Box
          w={10} h={10} borderRadius="12px" flexShrink={0}
          style={{ background: `linear-gradient(135deg, ${PRIMARY_BG} 0%, var(--brand-primary-hover) 100%)` }}
          display="flex" alignItems="center" justifyContent="center"
          shadow={`0 4px 12px ${PRIMARY_BG}45`}
        >
          <Icon as={icon} boxSize="17px" color="white" />
        </Box>
      )}
      <Box minW={0}>
        <Text as="h1" fontSize="19px" fontWeight="500" color="gray.800" letterSpacing="-0.01em">{title}</Text>
        {subtitle && <Text fontSize="12.5px" color="gray.500">{subtitle}</Text>}
      </Box>
    </Flex>
    {children && (
      <Flex align="center" gap={3} wrap="wrap">
        {children}
      </Flex>
    )}
  </Flex>
);

export default PageHeading;
